import { render, staticRenderFns } from "./UpdateMaterialform.vue?vue&type=template&id=85a61128&"
import script from "./UpdateMaterialform.vue?vue&type=script&lang=js&"
export * from "./UpdateMaterialform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports